// Mirrors MC.NET.Client/Inventory/ItemStack.cs (protocol 47 wire DTO).
export interface ItemStack {
    itemId: number;
    count: number;
    damage: number;
    snbt?: string;
    identifier?: string;
    name?: string;
}

export interface ItemStackNbt {
    ench?: { id: number; lvl: number }[];
    displayName?: string;
    lore?: string[];
    potion?: string;
    customPotionEffects?: { id: number; amplifier: number; duration: number }[];
    unbreakable?: boolean;
    repairCost?: number;
    skullOwner?: SkullOwnerNbt;
    // GrieferGames' own name for a filled map's picture; the damage id changes on every citybuild join.
    map3?: string;
    // Top-level keys only, the same number the vanilla advanced tooltip prints as "NBT: n tag(s)".
    tagCount?: number;
}

export interface SkullOwnerNbt {
    id?: string;
    name?: string;
    textureValue?: string;
}

export interface PotionBitfield {
    empty: boolean;
    effectId: number;
    tierII: boolean;
    extended: boolean;
    splash: boolean;
}

export interface ItemRef {
    itemId: number;
    metadata: number;
    name?: string;
}

export function isEmptyStack(stack: ItemStack | null | undefined): boolean {
    if (!stack) return true;
    if (stack.count <= 0) return true;
    if (stack.itemId >= 0) return false;
    if (stack.identifier || stack.name) return false;
    return true;
}

// Slot payloads arrive rebuilt on every inventory push, so identity says nothing about whether the
// item changed. Tiles diff on this instead and keep their icon, tooltip and badge DOM across a push
// that left them alone.
export function itemStackSignature(stack: ItemStack): string {
    return `${stack.itemId}|${stack.count}|${stack.damage}|${stack.snbt ?? ""}|${stack.identifier ?? ""}|${stack.name ?? ""}`;
}

export function sameItemStack(a: ItemStack | null | undefined, b: ItemStack | null | undefined): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    return itemStackSignature(a) === itemStackSignature(b);
}
